const BROWSER_PREVIEWABLE = new Set(["pdf", "png", "jpg", "jpeg", "gif", "webp", "txt"]);
const IMAGE_EXTENSIONS = new Set(["png", "jpg", "jpeg", "gif", "webp", "heic"]);
const TEXT_PREVIEW_EXTENSIONS = new Set(["txt", "csv", "json", "xml", "log"]);
const EMAIL_PREVIEW_EXTENSIONS = new Set(["eml", "emlx", "msg"]);

/** Max. Dateigrösse für Textvorschau im Modal (Bytes). */
export const MAX_TEXT_PREVIEW_BYTES = 512 * 1024;

function normalizeExt(ext = "") {
  return String(ext || "").toLowerCase().replace(/^\./, "");
}

export function getFileExtension(name = "") {
  return String(name).toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] || "";
}

export function isTextPreviewFile(ext = "") {
  return TEXT_PREVIEW_EXTENSIONS.has(normalizeExt(ext));
}

export function isEmailPreviewFile(ext = "") {
  return EMAIL_PREVIEW_EXTENSIONS.has(normalizeExt(ext));
}

export function isBrowserPreviewable(ext = "") {
  const e = normalizeExt(ext);
  return (
    BROWSER_PREVIEWABLE.has(e) ||
    TEXT_PREVIEW_EXTENSIONS.has(e) ||
    EMAIL_PREVIEW_EXTENSIONS.has(e)
  );
}

export function isImageFile(ext = "") {
  return IMAGE_EXTENSIONS.has(normalizeExt(ext));
}

export function isPdfFile(ext = "") {
  return normalizeExt(ext) === "pdf";
}

/**
 * Vorschau-Strategie für FilePreviewModal (Legacy ohne Meta-API).
 * @returns {"direct"|"text"|"email"|"unsupported"}
 */
export function getPreviewStrategy(ext = "", { isMobile = false } = {}) {
  const e = normalizeExt(ext);
  if (isImageFile(e)) return "direct";
  if (isPdfFile(e)) return "direct";
  if (isEmailPreviewFile(e)) return "email";
  if (isTextPreviewFile(e)) return "text";
  return "unsupported";
}

/** Ob das Modal für diesen Typ Inhalt anzeigen kann. */
export function supportsModalPreview(ext = "", { isMobile = false } = {}) {
  const strategy = getPreviewStrategy(ext, { isMobile });
  return strategy === "direct" || strategy === "text" || strategy === "email";
}

export function shouldUsePreviewMeta({ previewModule, fileId } = {}) {
  const mod = String(previewModule || "").trim();
  const fid = Number(fileId);
  return Boolean(mod && Number.isFinite(fid) && fid > 0);
}

export function getFileType(ext = "") {
  if (isPdfFile(ext)) return "pdf";
  if (isImageFile(ext)) return "image";
  if (isMsgExtension(ext)) return "msg";
  if (isEmailPreviewFile(ext)) return "email";
  if (isTextPreviewFile(ext)) return "text";
  if (BROWSER_PREVIEWABLE.has(normalizeExt(ext))) return "text";
  return "file";
}

export function isMsgExtension(ext = "") {
  return normalizeExt(ext) === "msg";
}

/** @deprecated MSG wird serverseitig über preview-meta angezeigt. */
export function isMsgMobilePreviewEnabled() {
  return false;
}

/** @deprecated Einheitliche Vorschau über FilePreviewModal + preview-meta. */
export function shouldUseMsgMobilePreview() {
  return false;
}

export function sanitizeFileUrl(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (raw.startsWith("//")) return "";
  if (raw.startsWith("/")) return raw;
  if (typeof window === "undefined" || !window?.location?.origin) return "";
  try {
    const parsed = new URL(raw);
    return parsed.origin === window.location.origin ? parsed.toString() : "";
  } catch {
    return "";
  }
}
